import React from "react";
import { css } from "glamor";
import { FaShoppingCart } from "react-icons/fa";
import { Table } from "semantic-ui-react";
import Card from "../library/Card";
import Pagination from "../library/Pagination";
import Label from "../library/Label";
import { colors, spacing } from "../library/theme";
import { toBRLCurrency } from "../../utils/formatCurrency";
import { getPurchaseGroupStatusText, getPurchaseGroupStatusColor, getPaymentMethodText } from "./productHelpers";
import formatDate from "../../utils/formatDate";

const container = css({
  marginBottom: spacing.m,
});

const tableWrapperClass = css({
  borderRadius: spacing.m,
  background: colors.white,
  "> table": {
    border: "none !important",
    boxShadow: "none !important",
  },
});

const tableHeaderCell = css({
  backgroundColor: `${colors.greyLight} !important`,
  ":first-child": {
    borderTopLeftRadius: `${spacing.xs} !important`,
    borderBottomLeftRadius: `${spacing.xs} !important`,
  },
  ":last-child": {
    borderTopRightRadius: `${spacing.xs} !important`,
    borderBottomRightRadius: `${spacing.xs} !important`,
  },
}).toString();

const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: spacing.xs,
};

const paginationContainer = css({
  paddingTop: spacing.s,
  display: "flex",
  justifyContent: "center",
});

export default function ProductPurchases({
  purchases = [],
  page = 1,
  onPageChange,
  totalPages = 1
}) {
  return purchases.length > 0 ? (
    <div className={container}>
      <Card fluid>
        <Card.Content>
          <Card.Header style={headerStyle}>
            <FaShoppingCart /> Compras
          </Card.Header>
        </Card.Content>
        <Card.Content>
          <div className={tableWrapperClass}>
            <Table striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell className={tableHeaderCell}>
                    Data
                  </Table.HeaderCell>
                  <Table.HeaderCell className={tableHeaderCell}>
                    Valor
                  </Table.HeaderCell>
                  <Table.HeaderCell className={tableHeaderCell}>
                    Método de Pagamento
                  </Table.HeaderCell>
                  <Table.HeaderCell className={tableHeaderCell}>
                    Status
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {purchases.map((purchase) => (
                  <Table.Row key={purchase.id}>
                    <Table.Cell>
                      {formatDate(purchase.createdAt, "DD/MM/yyyy")}
                    </Table.Cell>
                    <Table.Cell>
                      {toBRLCurrency(purchase.productPrice)}
                    </Table.Cell>
                    <Table.Cell>
                      {getPaymentMethodText(purchase.paymentType)}
                    </Table.Cell>
                    <Table.Cell>
                      <Label color={getPurchaseGroupStatusColor(purchase.groupStatus)}>
                        {getPurchaseGroupStatusText(purchase?.groupStatus)}
                      </Label>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
          {totalPages > 1 && (
            <div className={paginationContainer}>
              <Pagination
                activePage={page}
                totalPages={totalPages}
                onPageChange={onPageChange}
                size="mini"
              />
            </div>
          )}
        </Card.Content>
      </Card>
    </div>
  ) : null;
}
